import { Checkbox } from "antd";
import classes from "./Filters.module.scss";

export const ReviewFilters = ({
  reviewFilter,
  setReviewFilter,
  allDestinations,
  tripTypeOptions,
}) => {
  const handleFilterChange = (e) => {
    const { name, value, checked } = e.target;

    // current array for this filter name
    const current = Array.isArray(reviewFilter[name]) ? reviewFilter[name] : [];

    // normalize values per filter
    const normVal = name === "type" ? Number(value) : String(value); // type:number, location:string

    let next = current;
    if (checked) {
      // add if not exists
      if (!current.some((v) => String(v) === String(normVal))) {
        next = [...current, normVal];
      }
    } else {
      // remove
      next = current.filter((v) => String(v) !== String(normVal));
    }

    setReviewFilter((prev) => ({ ...prev, [name]: next }));
  };
  return (
    <div className={classes.reviews_filters}>
      <div className={classes.filter}>
        <h3 className={classes.reviews_filters__title}>Programs</h3>

        <ul className={classes.filters_list}>
          {tripTypeOptions.map((type, index) => (
            <li key={index} className={classes.filter_item}>
              <Checkbox
                onChange={(e) => handleFilterChange(e)}
                name="type"
                value={type.id}
              />
              <span>{type.label}</span>
            </li>
          ))}
        </ul>
      </div>
      <div className={classes.filter}>
        <h3 className={classes.reviews_filters__title}>Destinations</h3>

        <ul className={classes.filters_list}>
          {allDestinations.map((type, index) => (
            <li key={index} className={classes.filter_item}>
              <Checkbox
                onChange={(e) => handleFilterChange(e)}
                name="location"
                value={type}
              />
              <span>{type}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ReviewFilters;
